import { render } from "./CaretComponent.vue?vue&type=template&id=084f7e18&scoped=true"
import script from "./CaretComponent.vue?vue&type=script&lang=js"
export * from "./CaretComponent.vue?vue&type=script&lang=js"

import "./CaretComponent.vue?vue&type=style&index=0&id=084f7e18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084f7e18"]])

export default __exports__